import { Component } from '@angular/core';  
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../components/layout/header/header.component';
import { FormStateService } from '../../services/form-state.service';
import { StepOneComponent } from '../../components/auto-apertura/step-one/step-one.component';
import { FormNavigationComponent } from '../../components/auto-apertura/form-navigation/form-navigation.component';
import { StepsIndicatorComponent } from '../../components/auto-apertura/steps-indicator/steps-indicator.component';
import { VerificationModalService } from '../../services/verification-modal.service';
import { DocumentModalService } from '../../services/document-modal.service';
import { StepTwoOneComponent } from '../../components/auto-apertura/step-two-one/step-two-one.component';
import { StepTwoTwoComponent } from '../../components/auto-apertura/step-two-two/step-two-two.component';
import { StepThreeComponent } from '../../components/auto-apertura/step-three/step-three.component';
import { StepFourComponent } from '../../components/auto-apertura/step-four/step-four.component';
import { StepFiveComponent } from '../../components/auto-apertura/step-five/step-five.component';
import { StepSixComponent } from '../../components/auto-apertura/step-six/step-six.component';
import { ComprobanteComponent } from '../../components/auto-apertura/comprobante/comprobante.component';
import { VerificationModalComponent } from '../../components/common/verification-modal/verification-modal.component';
import { DocumentModalComponent } from '../../components/common/document-modal/document-modal.component';

@Component({
  selector: 'app-auto-apertura',
  standalone: true,
  imports: [CommonModule, HeaderComponent, StepsIndicatorComponent, FormNavigationComponent, StepOneComponent, StepTwoOneComponent, StepTwoTwoComponent, StepThreeComponent, StepFourComponent, StepFiveComponent, StepSixComponent, ComprobanteComponent, VerificationModalComponent, DocumentModalComponent],
  templateUrl: './auto-apertura.component.html',
  styleUrls: ['./auto-apertura.component.scss']
})  
export class AutoAperturaComponent {
  currentStep = 1;
  currentSubStep = 1;
  showComprobante = false;
  allDocumentsSigned = false;
  aceptacionFinal = false;
  phoneNumber = '+56 9XXXXXXXX';
  userName = '';
  seguroOption = '';
  diaPago = '';
  documentosFirmados: { [key: string]: boolean } = {};

  // Estado y datos del modal de verificación
  showVerificationModal = false;
  verificationCode: string[] = ['', '', '', '', '', ''];
  verificationTimer = 30;
  isVerificationCodeComplete = false;
  private verificationInterval: any;

  // Estado del modal de documentos
  showDocumentModal = false;
  documentTitle = '';
  zoomLevel = 100;

  // Handlers para outputs
  setPhoneNumber(phone: string) { this.phoneNumber = phone; }
  setSeguroOption(option: string) { this.seguroOption = option; }
  setDiaPago(dia: string) { this.diaPago = dia; }
  setAceptacionFinal(val: boolean) { this.aceptacionFinal = val; }
  openDocumentModal(title: string) {
    this.documentTitle = title;
    this.showDocumentModal = true;
    this.zoomLevel = 100;
  }

  openModal() {
    this.showVerificationModal = true;
    this.verificationTimer = 30;
    this.startVerificationTimer();
  }

  startVerificationTimer() {
    if (this.verificationInterval) {
      clearInterval(this.verificationInterval);
    }
    this.verificationInterval = setInterval(() => {
      if (this.verificationTimer > 0) {
        this.verificationTimer--;
      } else {
        clearInterval(this.verificationInterval);
      }
    }, 1000);
  }

  closeVerificationModal() {
    this.showVerificationModal = false;
    if (this.verificationInterval) {
      clearInterval(this.verificationInterval);
    }
    this.verificationCode = ['', '', '', '', '', ''];
  }

  onVerificationConfirm(code: string[]) {
    console.log('Código recibido en el padre:', code);
    this.closeVerificationModal();
    // Aquí puedes validar el código recibido
  }

  onVerificationCodeChange(event: { index: number, value: string }) {
    this.verificationCode[event.index] = event.value;
    this.isVerificationCodeComplete = this.verificationCode.every(d => d !== '');
  }

  onVerificationKeyDown(event: { index: number, event: KeyboardEvent }) {
    // Lógica para navegación entre inputs si lo deseas
  }

  closeDocumentModal() {
    this.showDocumentModal = false;
  }

  onDocumentSign() {
    // Aquí tu lógica de firmado
    this.closeDocumentModal();
  }

  onZoom(direction: 'in' | 'out') {
    if (direction === 'in' && this.zoomLevel < 200) {
      this.zoomLevel += 10;
    } else if (direction === 'out' && this.zoomLevel > 50) {
      this.zoomLevel -= 10;
    }
  }

  constructor(
    private formStateService: FormStateService,
    private verificationModalService: VerificationModalService,
    private documentModalService: DocumentModalService
  ) {}

  goToPreviousStep() {
    if (this.currentStep > 1) this.currentStep--;
  }

  goToNextStep() {
    if (this.currentStep < 6) this.currentStep++;
  }

  renderCurrentStep() {
    if (this.showComprobante) {
      return ComprobanteComponent;
    }
    switch (this.currentStep) {
      case 1:
        return StepOneComponent;
      case 2:
        return this.currentSubStep === 1 ? StepTwoOneComponent : StepTwoTwoComponent;
      case 3:
        return StepThreeComponent;
      case 4:
        return StepFourComponent;
      case 5:
        return StepFiveComponent;
      case 6:
        return StepSixComponent;
      default:
        return null;
    }
  }
}
